import {
  backdropClasses,
  Box,
  Button,
  SxProps,
  TableCellProps,
} from "@mui/material"
import { MRT_ColumnDef } from "material-react-table"
import { colors } from "../../../../styles/commonStyles"
import { strFormat } from "../ResourceBudgetTable/utils"
import {
  setSelectedTransactionClass,
  setTableType,
} from "../../../redux/slices/pnlReportingSlice"
import { tableTypes } from "../../../pages/PnlReporting/constants"
import {
  bottomFooterCellStyles,
  topFooterCellStyles,
} from "../PNLBudgetTable/pnlTableConfig"
import dayjs from "dayjs"
export const percentFormatter = ({ renderedCellValue, row }: any) => {
  return row.index
    ? `${parseFloat(renderedCellValue || "0").toFixed(0)} %`
    : null
}
export const amountFormatter = ({ renderedCellValue }: any) =>
  `$ ${parseInt(renderedCellValue || "0")
    .toLocaleString
    //   undefined,
    //   {
    //   minimumFractionDigits: 2,
    //   maximumFractionDigits: 2,
    // }
    ()}`

export const firstPercentOfSecond = (first: number, second: number) => {
  return ((first - second) / first) * 100
}

const ReportingFooter = (props: any) => {
  const { agg, column, precent } = props
  const key = column.columnDef.accessorKey
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        height: "100%",
        backgroundColor: colors.darkBlue,
      }}
    >
      <Box
        sx={{ ...topFooterCellStyles }}
        onClick={() => console.log("clicked")}
      >
        {precent ? "" : "$ "}
        {key == "difference"
          ? firstPercentOfSecond(
              parseInt(agg["exp"]?.["ytd_actual_amount"]),
              parseInt(agg["exp"]?.["py_actual_amount"]),
            ).toLocaleString(undefined, {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            })
          : parseInt(agg["exp"]?.[key] || "0.00").toLocaleString(undefined, {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            })}
        {precent ? " %" : ""}
      </Box>
      <Box sx={{ ...bottomFooterCellStyles }}>
        {precent ? "" : "$ "}
        {key == "difference"
          ? firstPercentOfSecond(
              parseInt(agg["ebitda"]?.["ytd_actual_amount"]),
              parseInt(agg["ebitda"]?.["py_actual_amount"]),
            ).toLocaleString(undefined, {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            })
          : parseInt(agg["ebitda"]?.[key] || "0").toLocaleString(undefined, {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            })}
        {precent ? " %" : ""}
      </Box>
    </Box>
  )
}
// const ReportingFooter = (column: any, agg: any, percent: boolean = false) => {
//   const key = column.columnDef.accessorKey
//   const formattedVal = parseInt(agg[key as string] || "0").toLocaleString(
//     undefined,
//     {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     },
//   )
//   return percent ? `${formattedVal} %` : `$ ${formattedVal}`
// }
const bodyCellStyles = ({ row }: any) => {
  return {
    align: "center",
    sx: {
      height: "48px",
      border: "1px solid #EFF0F5",
      fontWeight: row.index ? "400" : "600",
    },
  } as TableCellProps
}

const bodyNormalCellStyles: TableCellProps = {
  align: "center",
  sx: {
    height: "48px",
    border: "1px solid #EFF0F5",
  },
}

const footerStyles: TableCellProps = {
  align: "center",
  sx: {
    height: "100px",
    border: "1px solid #fff",
    color: "#fff",
    backgroundColor: colors.darkBlue,
    p: 0,
  },
}

const transactionTableFooterStyles = {
  backgroundColor: colors.darkBlue,
  color: "#fff",
  height: "48px",
  border: "0.5px solid #fff",
  pt: "12px",
}

const percentCellSize = 20
const amountCellSize = 50
export const generateReportingCols = (
  agg: any,
  selectedDate: any,
): MRT_ColumnDef<any>[] => [
  {
    header: "Line items",
    accessorKey: "line_item",
    size: 280,
    muiTableFooterCellProps: {
      sx: {
        ...footerStyles.sx,
        borderBottomLeftRadius: "5px",
      },
    },
    Footer: () => {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",
          }}
        >
          <Box
            sx={{
              ...topFooterCellStyles,
              pl: "20px",
              justifyContent: "flex-start",
            }}
          >
            Total Expenses
          </Box>
          <Box
            sx={{
              ...bottomFooterCellStyles,
              pl: "20px",
              justifyContent: "flex-start",
            }}
          >
            EBITDA
          </Box>
        </Box>
      )
    },
    // muiTableFooterCellProps: {
    //   sx: { ...footerCellStyles },
    // },
  },
  {
    header: "Actual",
    accessorKey: "actual_amount",
    aggregationFn: "sum",
    Cell: amountFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg }),
    muiTableFooterCellProps: footerStyles,
    muiTableBodyCellProps: bodyCellStyles,
    size: amountCellSize,
  },
  {
    header: "%",
    id: "actual_percentage",
    accessorKey: "actual_percentage",
    Cell: percentFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg, precent: true }),
    muiTableFooterCellProps: footerStyles,
    muiTableBodyCellProps: bodyCellStyles,
    size: amountCellSize,
  },
  {
    header: "Budget",
    accessorKey: "budget_amount",
    Cell: amountFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg }),
    muiTableFooterCellProps: footerStyles,
    muiTableBodyCellProps: bodyCellStyles,
    size: amountCellSize,
  },
  {
    header: "%",
    id: "budget_percentage",
    accessorKey: "budget_percentage",
    Cell: percentFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg, precent: true }),
    muiTableFooterCellProps: footerStyles,
    muiTableBodyCellProps: bodyCellStyles,
    size: percentCellSize,
  },
  {
    header: "Variance",
    accessorKey: "variance_amount",
    Cell: amountFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg }),
    muiTableFooterCellProps: footerStyles,
    muiTableBodyCellProps: bodyCellStyles,
    size: amountCellSize,
  },
  {
    header: "%",
    accessorKey: "variance_percentage",
    Cell: percentFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg, precent: true }),
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...footerStyles.sx,
        borderBottomRightRadius: "5px",
        borderRight: "2px solid grey", // Add thick border to separate sections
      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: "0.5px solid #E4E4E4",
        borderRight: "2px solid grey", // Add thick border to separate sections
        backgroundColor: "#1A428A",
        color: "#fff",
        padding: "12px 24px !important",
        textAlign: "center",
      },
    },
    muiTableBodyCellProps: {
      align: "center",
      sx: {
        height: "48px",
        border: "1px solid #EFF0F5",
        borderRight: "2px solid grey", // Add thick border to separate sections
      },
    },
    size: percentCellSize,
  },
  {
    header: "YTD Actual",
    accessorKey: "ytd_actual_amount",
    Cell: amountFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg }),
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...footerStyles.sx,
        borderBottomRightRadius: "5px",
        borderLeft: "2px solid grey", // Add thick border to separate sections
      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: "0.5px solid #E4E4E4",
        borderLeft: "2px solid grey", // Add thick border to separate sections
        backgroundColor: "#1A428A",
        color: "#fff",
        padding: "12px 24px !important",
        textAlign: "center",
      },
    },
    muiTableBodyCellProps({ row }: any): {} {
      return {
        align: "center",
        sx: {
          height: "48px",
          border: "1px solid #EFF0F5",
          borderLeft: "2px solid grey", // Add thick border to separate sections
          fontWeight: row.index ? "400" : "600",
        },
      }
    },
    size: amountCellSize,
  },
  {
    header: "%",
    accessorKey: "ytd_actual_percentage",
    Cell: percentFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg, precent: true }),
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...footerStyles.sx,
        borderBottomRightRadius: "5px",
      },
    },
    muiTableBodyCellProps: bodyCellStyles,
    size: percentCellSize,
  },
  {
    header: "YTD Budget",
    accessorKey: "ytd_budget_amount",
    Cell: amountFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg }),
    muiTableFooterCellProps: footerStyles,
    muiTableBodyCellProps: bodyCellStyles,
    size: amountCellSize,
  },
  {
    header: "%",
    accessorKey: "ytd_budget_percentage",
    Cell: percentFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg, precent: true }),
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...footerStyles.sx,
        borderBottomRightRadius: "5px",
      },
    },

    muiTableBodyCellProps: bodyCellStyles,
    size: percentCellSize,
  },
  {
    header: "YTD Variance",
    accessorKey: "ytd_variance_amount",
    Cell: amountFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg }),
    muiTableFooterCellProps: footerStyles,
    muiTableBodyCellProps: bodyCellStyles,
    size: amountCellSize,
  },
  {
    header: "%",
    accessorKey: "ytd_variance_percentage",
    Cell: percentFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg, precent: true }),
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...footerStyles.sx,
        borderBottomRightRadius: "5px",
        borderRight: "2px solid grey", // Add thick border to separate sections
      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: "0.5px solid #E4E4E4",
        borderRight: "2px solid grey", // Add thick border to separate sections
        backgroundColor: "#1A428A",
        color: "#fff",
        padding: "12px 24px !important",
        textAlign: "center",
      },
    },
    muiTableBodyCellProps: {
      align: "center",
      sx: {
        height: "48px",
        border: "1px solid #EFF0F5",
        borderRight: "2px solid grey", // Add thick border to separate sections
      },
    },
    size: percentCellSize,
  },
  {
    header: `${Number(selectedDate || 0) - 1} (PY) Actual`,
    accessorKey: "py_actual_amount",
    Cell: amountFormatter,
    Footer: ({ column }) => ReportingFooter({ column, agg }),
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...footerStyles.sx,
        borderBottomRightRadius: "5px",
        borderLeft: "2px solid grey", // Add thick border to separate sections
      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: "0.5px solid #E4E4E4",
        borderLeft: "2px solid grey", // Add thick border to separate sections
        backgroundColor: "#1A428A",
        color: "#fff",
        padding: "12px 24px !important",
        textAlign: "center",
      },
    },
    muiTableBodyCellProps({ row }: any): {} {
      return {
        align: "center",
        sx: {
          height: "48px",
          border: "1px solid #EFF0F5",
          borderLeft: "2px solid grey", // Add thick border to separate sections
          fontWeight: row.index ? "400" : "600",
        },
      }
    },
    size: amountCellSize,
  },
  {
    header: "% Difference",
    accessorKey: "difference",
    Cell({ renderedCellValue, row }: any) {
      return row.index
        ? `${parseFloat(renderedCellValue || "0").toFixed(0)} %`
        : `${parseInt(renderedCellValue).toLocaleString()}`
    },
    Footer: ({ column }) => ReportingFooter({ column, agg, precent: true }),
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...footerStyles.sx,
        borderBottomRightRadius: "5px",
      },
    },
    muiTableBodyCellProps: bodyCellStyles,
    size: percentCellSize,
  },
]

export const transactionTableCols = (
  transactionSum: string,
): MRT_ColumnDef<any>[] => [
  {
    header: "Transaction Date",
    accessorKey: "transaction_date",
    size: 150,
    muiTableBodyCellProps: bodyNormalCellStyles,
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...transactionTableFooterStyles,
        borderBottomLeftRadius: "5px",
        borderRightWidth: 0,
      },
    },
    footer: "Total",
  },
  {
    header: "Transaction Name",
    accessorKey: "transaction_name",
    size: 150,
    muiTableBodyCellProps: bodyNormalCellStyles,
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...transactionTableFooterStyles,
        borderRightWidth: 0,
        borderLeftWidth: 0,
      },
    },
    footer: "",
  },
  {
    header: "Transaction Memo",
    accessorKey: "transaction_memo",
    size: 600,
    muiTableBodyCellProps: bodyNormalCellStyles,
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...transactionTableFooterStyles,
        borderLeftWidth: 0,
      },
    },
    footer: "",
  },
  {
    header: "Transaction Amount",
    accessorKey: "transaction_amount",
    Cell: amountFormatter,
    size: 150,
    muiTableBodyCellProps: bodyNormalCellStyles,
    muiTableFooterCellProps: {
      align: "center",
      sx: {
        ...transactionTableFooterStyles,
        borderBottomRightRadius: "5px",
      },
    },
    footer: `$ ${transactionSum}`,
  },
]

export const generatePNLReportingDetailCols = (
  data: any,
  agg: any,
  dispatch: any,
) => {
  const ref = data?.[0] || {}
  let cols: MRT_ColumnDef<any>[] = []

  Object.keys(ref).forEach((accessorKey: string) => {
    if (accessorKey === "account" || accessorKey === "current-account-class") {
      return
    }

    let col: MRT_ColumnDef<any> = {
      header: strFormat(accessorKey.replaceAll("-", " ")),
      size: 150,
      accessorKey,
    }
    let styles: SxProps = {}
    let footerSx: any = {}

    if (accessorKey === "account-class") {
      styles = {
        fontWeight: "bold",
      }
      footerSx = {
        borderRightWidth: 0,
      }
      col.size = 250
      col.footer = "Total"
    } else if (accessorKey === "account-sub-class") {
      col.size = 200
      col.Cell = ({ renderedCellValue, row }: any) => {
        return (
          <Button
            disabled={!Boolean(renderedCellValue)}
            disableTouchRipple
            variant="text"
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              textTransform: "none",
              fontWeight: "bold",
              color: "#3366D6",
              "&:Hover": {
                backgroundColor: "transparent",
              },
            }}
            onClick={() => {
              dispatch(
                setSelectedTransactionClass({
                  transactionAccount: row.original?.["account"],
                  transactionClass: row.original?.["current-account-class"],
                  transactionSubClass: row.original?.["account-sub-class"],
                }),
              )
              dispatch(setTableType(tableTypes.SUBDETAIL))
            }}
          >
            {renderedCellValue}
          </Button>
        )
      }
      footerSx = {
        borderLeftWidth: 0,
      }
    } else {
      col.size = 50
      col.Cell = amountFormatter
      col.footer = amountFormatter({ renderedCellValue: agg[accessorKey] })
    }

    col.muiTableBodyCellProps = ({ row }) => {
      return {
        align: "center",
        sx: {
          height: "48px",
          border: "1px solid #EFF0F5",
          borderTopColor:
            row.index && row.original.end ? "#8B8C90" : " #EFF0F5",
          ...styles,
        },
      }
    }
    col.muiTableFooterCellProps = {
      align: "center",
      sx: {
        backgroundColor: colors.darkBlue,
        color: "#fff",
        height: "48px",
        border: "0.5px solid #fff",
        pt: "12px",
        ...footerSx,
      },
    }

    cols.push(col)
  })
  return cols
}
